/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getEventId } from '@braindate/domain/lib/event/util';
import { getUserId } from '@braindate/domain/lib/user/util';

import { USER_AUTOCOMPLETE } from 'src/shared/domain/user/action/userActionNamespaces';

import FieldUserAutocompleteDumb from './FieldUserAutocompleteDumb';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';
import withFeatureDecisions from 'src/shared/app/feature/component/withFeatureDecisions';
import withMount from 'src/shared/app/base/component/hoc/withMount';
import type { State } from 'src/shared/core/type/reduxTypes';
import {
  fetchUsers,
  resetUsers,
} from 'src/shared/domain/user/action/userActions';
import {
  getUsersAutocomplete,
  isUsersAutocompleteFetching,
  getUsersAutocompleteCount,
} from 'src/shared/app/user/selector/userAutocompleteSelectors';

import { getUserId as getSelfUserID } from 'src/shared/domain/user/selector/userSelectors';

import type { BraindateEvent } from '@braindate/domain/lib/event/type';
import type { User } from '@braindate/domain/lib/user/type';

type Props = {
  suppParams: Object,
  label: string,
  possibleValues?: User[],
  readOnly?: boolean,
  disabled?: boolean,
};

type StateProps = {
  event: BraindateEvent,
  hasDefaultValues: boolean,
  users: User[],
  readOnly?: boolean,
};

export const userAutocompleteFieldName = 'user';

const mapStateToProps = (state: State, props: Props): StateProps => {
  const event = getEventSafely(state);

  const { possibleValues } = props;

  return {
    event,
    hasDefaultValues: !!possibleValues && !!possibleValues.length,
    users: possibleValues
      ? possibleValues
      : getUsersAutocomplete(state).filter(
          (u) => getSelfUserID(state) !== getUserId(u),
        ),
    count: getUsersAutocompleteCount(state),
    isFetching: isUsersAutocompleteFetching(state),
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: StateProps,
  { dispatch }: any,
  ownProps: Props,
): Object => {
  const { event, hasDefaultValues } = stateProps;
  const { suppParams, label, readOnly, disabled } = ownProps;
  const eventId = getEventId(event);
  return {
    ...stateProps,
    label,
    readOnly,
    disabled,
    handleSearch: (value) => {
      if (hasDefaultValues) return;
      if (value.length > 2) {
        dispatch(
          fetchUsers(
            eventId,
            { q: value, limit: 3, ...suppParams },
            USER_AUTOCOMPLETE,
          ),
        );
      } else {
        dispatch(resetUsers(USER_AUTOCOMPLETE));
      }
    },
    handleChange() {
      dispatch(resetUsers(USER_AUTOCOMPLETE));
    },
    handleMount() {
      dispatch(resetUsers(USER_AUTOCOMPLETE));
    },
  };
};

export default compose(
  injectIntl,
  withFeatureDecisions,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  withMount,
)(FieldUserAutocompleteDumb);
